import * as React from "react";
import "./ImageItemGrid.sass"
import PropTypes from "prop-types";
import {Link} from "react-router-dom";

export default function ImageItemGrid(props) {
    const {image, title, link, style, onClick, imgStyle} = props
    const isExistsImage = image.indexOf("/null") === -1;
    return (
        <Link to={link || '/'}
              className="image-item-grid-wrapper"
              onClick={onClick || (() => {})}
              style={style}>
            <div className="image-item-grid-content">
                <div className="image-item-grid-image">
                    {
                        isExistsImage ? <img style={imgStyle && imgStyle} src={image} alt={title}/> : ""
                    }

                </div>
                <div className="image-item-grid-title">
                    <span>{title}</span>
                </div>
            </div>
        </Link>
    )
}

ImageItemGrid.propTypes = {
    image: PropTypes.string,
    title: PropTypes.string,
    link: PropTypes.string,
    style: PropTypes.object,
    onClick: PropTypes.func,
    imgStyle: PropTypes.object,
}